<template>
  <div class="settings-page">
    <h1>Indstillinger</h1>
    
    <section class="settings-section">
      <h2>Visning</h2>
      <VatToggle />
    </section>
  </div>
</template>

<script>
import VatToggle from '@/app/components/ui/VatToggle.vue';

export default {
  name: 'SettingsPage',
  components: {
    VatToggle
  }
};
</script>

<style scoped>
.settings-page {
  padding: 2rem;
  max-width: 800px;
}

.settings-page h1 {
  margin-bottom: 2rem;
  color: var(--primary-text-color);
}

.settings-section {
  margin-bottom: 2rem;
}

.settings-section h2 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--secondary-text-color);
}
</style>
